// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function userRetrieveById(params: { user_id: string }) {
  return http<{
    id: number
    name: string | null
    email: string
    avatar_url: string
    created: string
    stats: {
      recipesAdd: number
      recipesArchived: number
      scheduled: number
      comments: number
      photos: number
      primaryPhotos: number
    }
    activity: Array<{
      recipe_id: number
      recipe_name: string
      created_date: string
      created: string
      note_id: number
      type:
        | "recipe_create"
        | "comment_create"
        | "recipe_archived"
        | "recipe_scheduled"
        | "photo_created"
        | "primary_photo_created"
    }>
  }>({
    url: "/api/v1/user/{user_id}/",
    method: "get",
    params,
    pathParamNames: ["user_id"],
  })
}
